const NotFoundPage = () => {
    return (
        <div className="flex flex-col items-center justify-center h-screen">
            <div className="flex flex-col items-center justify-center gap-3 text-center">
                <h1 className="text-5xl font-bold">404</h1>
                <p className="text-2xl font-semibold">Halaman tidak ditemukan</p>
                <p className="text-sm">Kamu telah menemukan halaman yang tidak ada</p>
            </div>
        </div>
    )
}

export default NotFoundPage